<app-page-header icon="category" title="Rubros" subtitle="Listado de rubros del sistema"></app-page-header>

<app-spinner [show]="!flagLoaded" [type]="'fullscreen'" [color]="'#B1476A'" [trackColor]="'#4CA7C8'" [text]="'Cargando rubros...'" [showText]="true" [blurBackground]="true"></app-spinner>

<div *ngIf="flagLoaded" class="profile-area pb-70">
    <div class="container">
        <div class="profile-courses-quizzes">
            <h3>Listado de Rubros</h3>
            <br>
            <a routerLink="/rubro-alta"><button mat-raised-button mat-button color="primary"><mat-icon
                        aria-hidden="false" aria-label="Example home icon">add</mat-icon> Nuevo
                    Rubro</button></a>
            <br>
            <hr>
            <div *ngIf="flagLoaded">

                <mat-form-field>
                    <mat-label>Filtrar</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Rubro..." autocomplete="off"
                        #input style="width: 30%;">
                </mat-form-field>

                <div class="mat-elevation-z8">

                    <table mat-table [dataSource]="dataSource" matSort>

                        <!-- Column -->
                        <ng-container matColumnDef="rubro">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Rubro </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.concepto}} </td>
                        </ng-container>

                        <!-- Column -->
                        <ng-container matColumnDef="activo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Activo </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.logico_1 ? "Si" : "No" ||
                                'SIN DATOS
                                ASOCIADOS'}} </td>
                        </ng-container>

                        <!-- Column -->
                        <ng-container matColumnDef="_id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Acciones </th>
                            <td mat-cell *matCellDef="let element">
                                <button style="margin-right: 5px;" (click)="verRubro(element._id)"
                                    type="button" title="Modificar datos del rubro"
                                    class="btn btn-warning"><i class="fas fa-edit"></i></button>
                            </td>
                        </ng-container>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data matching
                                the
                                filter {{input.value}}</td>
                        </tr>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns">
                        </tr>
                        <tr mat-row 
                            *matRowDef="let row; columns: displayedColumns; when: hasData" 
                            [class.inactive-row]="!row.logico_1"
                            class="example-element-row">
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[50, 100, 150, 200, 500, 800]"
                        aria-label="Select page of campus"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>